/** @format */

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconArrowLeft,
	homefieldIconArrowRight,
	homefieldIconStarFilled,
	homefieldIconStarHalf,
	homefieldIconStarOutlined
} from '@dsg-tech/homefield-angular-icons';

import { CertonaRecommendationsComponent } from './components/certona-recommendations/certona-recommendations.component';
import { CommonModule } from '@angular/common';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { MatExpansionModule } from '@angular/material/expansion';
import { MediaModule } from '@shared/media/components';
import { NgModule } from '@angular/core';
import { ProTipsComponent } from '@shared/components';
import { SearchdexComponent } from './components/searchdex/searchdex.component';
import { SeoService } from '@seo/data-access';
import { ThirdPartyComponent } from './third-party.component';
import { WindowModule } from '@shared/data-access/services';

@NgModule({
	providers: [SeoService],
	imports: [
		CommonModule,
		HomefieldIconLibraryModule,
		HtmlSanitizerPipe,
		MatExpansionModule,
		MediaModule,
		ProTipsComponent,
		WindowModule
	],
	exports: [ThirdPartyComponent],
	declarations: [CertonaRecommendationsComponent, SearchdexComponent, ThirdPartyComponent]
})
export class ThirdPartyModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconArrowLeft,
			homefieldIconArrowRight,
			homefieldIconStarFilled,
			homefieldIconStarHalf,
			homefieldIconStarOutlined
		]);
	}
}
